import React, {useEffect, useState} from 'react';

interface Props {
    seconds: number;
    onExpire: () => void;
}

const RoundTimer: React.FC<Props> = ({seconds, onExpire}) => {
    const [left, setLeft] = useState(seconds);

    useEffect(() => {
        setLeft(seconds);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (left <= 0) {
            onExpire();
            return;
        }
        const timeout = setTimeout(() => setLeft(l => l - 1), 1000);
        return () => clearTimeout(timeout);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [left]);

    const mm = Math.floor(left / 60).toString().padStart(2, '0');
    const ss = (left % 60).toString().padStart(2, '0');

    return <div className={`GmTimer-clock ${left <= 5 ? 'GmTimer-clock--done' : ''}`}>{mm}:{ss}</div>;
};

export default RoundTimer;
